import React, { useEffect, useState } from 'react'
import Header from './header'
import { loadList } from '../../../store/prescription'
import Task from './../dashboard/task'
import bluestar from '../../../include/images/blue-star-icon.svg'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import checkcircle from '../../../include/images/check-circle-09.svg'
import verticalDots from '../../../include/images/vertical-dots.svg'
import videoslash from '../../../include/images/video-slash.svg'
import phoneslash from '../../../include/images/phone-slash.svg'
import shareIcon from '../../../include/images/share.svg'
import mindy from '../../../include/images/YM_Character_4.svg'
import shareClose from '../../../include/images/share_close.svg'
import tabDoc from '../../../include/images/tab-document.svg'
import iosExit from '../../../include/images/ios-exit.svg'
import timer from '../../../include/images/clock-regular-full (1).svg'
import fullScreenImg from '../../../include/images/fullscreen-icon.svg'
import videosOn from '../../../include/images/Videoon.png'
import micOn from '../../../include/images/micon.png'
import msgIcon from '../../../include/images/tab-message.svg'
import presC from '../../../include/images/precriptions-icon.svg'
import taskIcon from '../../../include/images/tab-dashboard.svg'
import notesIcon from '../../../include/images/notes-icon.svg'
import followUp from '../../../include/images/followup-icon.svg'
import Timer from '../../common/timer'
import moment from 'moment'
import Scrollbars from 'react-custom-scrollbars-2'
import LoadVideoCall from '../../video-call/loadVideoCall';
import LoadScreenShare from '../../video-call/loadScreenShare';

import {
  asktoJoin,
  foreClose,
  getAppointment,
  loadAllAppointmentForDoctor,
  loadAppointmentDetail,
  noShow,
} from '../../../store/appointment'
import { loadSeo } from '../../../store/seo'
import { getDoctor, loadDoctorProfile } from '../../../store/doctor'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import Messeges from './messeges'
import ListPrescription from './prescription/listPrescriptionVideoCall'
import ListFollowup from './prescription/listFollowup'
import Followup from './../dashboard/followUp/followUp'
import NotesThoughtVideoCall from './notesThoughtVideoCall'
import AvtarImage from '../../common/avtarImage'
import { Link } from 'react-router-dom'
import SettingPopup from './settingPopup'
import { getPatient, patientDetail } from '../../../store/patient'
import SummaryVid from './summaryVid'
import closeIcon from '../../../include/images/close.svg'
import { collection, query, where, getDocs } from "firebase/firestore";

import './style.css'
import { Modal } from 'react-bootstrap'
import AlertSuccess from '../../common/alertSuccess'
import AlertError from '../../common/alertError'
import { toast } from 'react-toastify'
import { db } from '../../../firebase'

function VideoCall(props) {

  const [isShow3, setShow3] = useState(false)
  const [popup, setPopup] = useState(false)
  const [popup2, setPopup2] = useState(false)
  const [askToJoinClicked, setAskToJoinClicked] = useState(false);
  const [dropDown, setDropDown] = useState(false)
  const [data, setData] = useState({})
  const [caseRecord, setCaseRecord] = useState({})
  const [video, setVideo] = useState(true)
  const [audio, setAudio] = useState(true)
  const [fullScreen, setFullScreen] = useState(false)
  const [tab, setTab] = useState('notes')
  const [localMedia, setLocalMedia] = useState([])
  const [screenShare, setScreenShare] = useState(false);
  const [userToken, setUserToken] = useState({});
  const [client, setClient] = useState();
  const [loadContent, setLoadContent] = useState();

  const [initial, setInitial] = useState(true)
  const [showUnreadDot, setShowUnreadDot] = useState(false);

  const toggle3 = () => {
    setShow3(!isShow3)
  }
  const changeTab = (tab, e) => {
    e.preventDefault()
    setTab(tab)
  }
  const toggleFull = () => {
    setFullScreen(!fullScreen)
  }
  const muteVideo = () => {
    if (localMedia.length > 1) {
      if (video) {
        localMedia[1].setEnabled(false)
      } else {
        localMedia[1].setEnabled(true)
      }
    }
    setVideo(!video)
  }

  const muteAudio = () => {
    if (localMedia.length > 1) {
      if (audio) {
        localMedia[0].setVolume(0)
        //localStream.muteAudio();
      } else {
        localMedia[0].setVolume(100)
        //localStream.unmuteAudio();
      }
    }
    setAudio(!audio)
  }

  const leave = async () => {
    if (localMedia.length > 1) {
      localMedia[0].close()
      localMedia[1].close()
    }
    await client.leave()
    if (window.opener) {
      console.log("prescription-updated----->")
    window.opener.postMessage("prescription-updated", "*");
    }
    window.close()
  }
  const handleScreenShareStart = async ()=>{
    if(!screenShare){
      await client.leave();
      props.loadAppointmentDetail(
        props.match.params.appointment_id,
        res => {
          if (res && res.data) {
            setScreenShare(true);
            setUserToken({
              screenShare:true,
              token:res.data.tokenA,
              uid:res.data.uid
            });
          }
        }
      )
    }
  }
  const handleAskToJoin = async (e, id) => {
    e.preventDefault();
  if (askToJoinClicked) return; 

  setAskToJoinClicked(true); 

  try {

    props.asktoJoin(id, joinCallBack);

    } catch (error) {
      console.error('Failed to send Request', error);
      setAskToJoinClicked(false); 
    }
  };
  
  const joinCallBack = (res) => {
    // console.log("joinCallBack res ---------> ", res)
    if (res.data?.success) {
      toast(<AlertSuccess message={'Request sent!'} />);
    } else {
      toast(<AlertError message={'Failed to send Request'} />);
      setAskToJoinClicked(false); 
    }
  };

  const noShow = (e, id) => {
    // this.setState({ appointmentId: '' })
    e.preventDefault()
    props.noShow(id, callbackNoShow)
  }
  const callbackNoShow = res => {
    props.loadAllAppointmentForDoctor({
      appointment_date: moment().format('YYYY-MM-DD'),
    })
    if (res.status === 200) {
      toast(<AlertSuccess message={'Record updated.'} />)
    } else {
      toast(<AlertError message={'Something went wrong.'} />)
    }
  }

  const handelForclose = (e, id) => {
    e.preventDefault()
    setPopup2(!popup2)
    props.foreClose(id, callbackForeclose)
  }

  const callbackForeclose = res => {
    props.loadAllAppointmentForDoctor({
      appointment_date: moment().format('YYYY-MM-DD'),
    })
    if (res.status === 200) {
      window.close()
      toast(<AlertSuccess message={'Record updated.'} />)
    } else {
      toast(<AlertError message={'Something went wrong.'} />)
    }
  }

  const handleScreenShareEnd = async ()=>{
    if(screenShare){
      //localMedia[1].close()
      localMedia.map(l=>l.close())
      await client.leave();
      window.location.reload();
      props.loadAppointmentDetail(
        props.match.params.appointment_id,
        res => {
          if (res && res.data) {
            setScreenShare(false);
            setUserToken({
              screenShare:false,
              token:res.data.tokenA,
              uid:res.data.uid
            });
          }
        }
      )
    }
  }
  const getTime = (time) => {
    const hours = Math.floor(time / 3600000);
    const minutes = Math.floor((time % 3600000) / 60000);
    const seconds = Math.floor((time % 60000) / 1000);

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };
  // useEffect(() => {
  //   props.loadAppointmentDetail(props.match.params.appointment_id, res => {
  //     if (res && res.data) {
  //       setData(res.data.data)
  //       setCaseRecord(res.data.caseRecord);
  //       setData(res.data.data)
  //       setUserToken({
  //         screenShare:false,
  //         token:res.data.tokenA,
  //         uid:res.data.uid
  //       })
  //     }
  //   })
  
  //   props.loadList({
  //     appointment_date: moment().format('YYYY-MM-DD'),
  //   })
  //   return () => {
  //     leave()
  //   }
  // }, []);

  useEffect(() => {
    let warningTimer;

    props.loadAppointmentDetail(props.match.params.appointment_id, res => {
      if (!res?.data?.data) return;

      setData(res.data.data);
      setCaseRecord(res.data.caseRecord);
      setUserToken({
        screenShare: false,
        token: res.data.tokenA,
        uid: res.data.uid,
      });

      const appointment = res.data.data;
      if (!appointment?.duration) return;

      const callStart = new Date(appointment.call_started_at).getTime();
      const duration = appointment.duration * 60 * 1000;
      const callEnd = callStart + duration;
      const warningTime = callEnd - 5 * 60 * 1000;
      const now = Date.now();

      console.log("Time left ----->",getTime(warningTime - now))

      if (now <= warningTime) {
        warningTimer = setTimeout(() => {
          toast.warning("Your appointment has 5 mins left.", {
            autoClose: false,
            closeOnClick: true,
            icon: <img src={mindy} alt="mindy" style={{ transform: "scale(4)" }}/>,
          });
        }, warningTime - now);
      }
    });

    props.loadList({
      appointment_date: moment().format('YYYY-MM-DD'),
    });

    return () => {
      if (warningTimer) clearTimeout(warningTimer);
      leave();
    };
  }, []);

  useEffect(() => {
    if (data && data.patient_id) props.patientDetail(data.patient_id._id)
    document.body.className = 'dashboard-video'

  }, [data])
  const getVideoContent = ()=>{
    return (   
      <LoadVideoCall 
        setLocalMedia={setLocalMedia} 
        channel={data._id}
        userToken={userToken}
        setClient={setClient}
        screenShare={screenShare}
        userType={"doctor"}
        />
      )
    }
  const getScreenShareContent = ()=>{
    return (      
        <LoadScreenShare 
          localMedia={localMedia} 
          setLocalMedia = {setLocalMedia}
          channel={data._id}
          userToken={userToken}
          shareScreen={handleScreenShareEnd}
          setClient={setClient}
          screenShare={screenShare}
        />
    )
  }
  useEffect(()=>{
    if(Object.keys(userToken).length > 0){
      if(userToken.screenShare) setLoadContent(getScreenShareContent())
      else setLoadContent(getVideoContent())
    }
  },[userToken]);

  useEffect(() => {
    const classData = document.getElementsByClassName('mcb-body-fullscreen')
    const topDar = document.getElementsByClassName('dashboard-top-bar')
    if (classData.length > 0 && topDar && topDar.length > 0) {
      topDar[0].style.zIndex = -999
    } else if (topDar && topDar.length > 0) {
      topDar[0].style.zIndex = 999
    }
    let localVideoTrack = localMedia && localMedia.length > 0 && localMedia[1]

    if (localVideoTrack) {
      if (fullScreen) {
        let localPlayerContainer = document.getElementById('agora_local_full')
        localPlayerContainer.innerHTML = ''
        localVideoTrack.play(localPlayerContainer)
      } else {
        let localPlayerContainer = document.getElementById('agora_local')
        localPlayerContainer.innerHTML = ''
        localVideoTrack.play(localPlayerContainer)
      }
    }
  }, [fullScreen])

  const loadNotification = async () => {
    if (!data?.doctor_id?._id) return;

    const q = query(
      collection(db, "chatsSummary"),
      where("doctorId", "==", data.doctor_id._id),
      where("readByDoctor", "==", false)
    );

    const snapshot = await getDocs(q);
    const unreadPatientIds = snapshot.docs.map(doc => doc.data().patientId);
    // console.log("unreadPatientIds----> ",unreadPatientIds)
    const isUnread = unreadPatientIds.includes(data.patient_id._id);
    // console.log("isUnread ----->", isUnread)
    if (isUnread) { 
      setShowUnreadDot(true);
    } else {
      setShowUnreadDot(false);
    }
  };
  
    useEffect(() => {
      loadNotification();
      const pollInterval = setInterval(() => {
        loadNotification();
      }, 5000);
  
      // cleanup on unmount
      return () => clearInterval(pollInterval);
    }, [data.doctor_id?._id]); 
  
    useEffect(() => {
      if(showUnreadDot){
        toast.info('You got a new message!', {
        autoClose: false,
        closeOnClick: true, 
        icon: <i class="fa-kit fa-svg-mindy"></i>,
      });
      }
    }, [showUnreadDot])

  return (
    <>
      {/* <Helmet>
        <script id='wati'>{WatiScript}</script>
      </Helmet> */}
      <Header />
      <ReactTooltip className='testPurple' id='videoCall-tt' />
      <div
        class='dashboard-main-container'
        onClick={e => {
          e.stopPropagation()
          setDropDown(false)
        }}>
        <div class='video-box video-box2 d-xl-flex flex-wrap'>
          <div
            className={
              fullScreen
                ? 'main-content-box main-content-box3'
                : 'main-content-box main-content-box2'
            }>
            <div class='mcb-head'>
              <div class='mcb-profile-head d-md-flex flex-wrap'>
                <div class='mcbp-left d-flex flex-wrap align-items-center'>
                  <div class='mcbp-img'>
                    {data && data.patient_id && data.patient_id.thumb ? (
                      <img
                        src={
                          process.env.REACT_APP_S3URL + data.patient_id.thumb
                        }
                        alt=''
                      />
                    ) : (
                      <AvtarImage />
                    )}
                  </div>
                  <div class='mcbp-desc'>
                    <div class='mcbp-text d-flex flex-wrap'>
                      <h4>
                        {data &&
                          data.patient_id &&
                          data.patient_id.first_name +
                            ' ' +
                            data.patient_id.last_name}
                      </h4>
                      <span>
                        {data &&
                          data.patient_id &&
                          data.patient_id.star &&
                          data.patient_id.star.length > 0 &&
                          data.patient_id.star.find(
                            e => e === props.doctorProfile._id
                          ) && (
                            <i>
                              <img src={bluestar} alt='star-icon' />
                            </i>
                          )}
                      </span>
                      <span>
                        {caseRecord && caseRecord.finish && (
                          <img src={checkcircle} alt='' />
                        )}
                      </span>
                    </div>
                    <div class='pd-right-content'>
                      <div class='d-flex flex-wrap'>
                        {caseRecord &&
                          caseRecord.finish &&
                          caseRecord.finish[
                            props.doctorProfile &&
                            props.doctorProfile.field_type &&
                            props.doctorProfile.field_type.name ===
                              'Psychologist'
                              ? 'diagnosis'
                              : 'diagnosisPsychiatrist'
                          ] &&
                          caseRecord.finish[
                            props.doctorProfile &&
                            props.doctorProfile.field_type &&
                            props.doctorProfile.field_type.name ===
                              'Psychologist'
                              ? 'diagnosis'
                              : 'diagnosisPsychiatrist'
                          ].diagnosis.length > 0 &&
                          caseRecord.finish[
                            props.doctorProfile &&
                            props.doctorProfile.field_type &&
                            props.doctorProfile.field_type.name ===
                              'Psychologist'
                              ? 'diagnosis'
                              : 'diagnosisPsychiatrist'
                          ].diagnosis.map(ecs => (
                            <>
                              <ReactTooltip
                                id={ecs.value}
                                className='testPurple'
                                // html={true}
                              />
                              <strong>{ecs.value}</strong>
                              <div class='custom-dropright mr-2'>
                                <div
                                  data-tooltip-id={ecs.value}
                                  data-tooltip-content={ecs.diagnosis}
                                  //data-tip={ecs.diagnosis}
                                  data-for={ecs.value}>
                                  <a class='custom-dropdown-toggle' href='#!'>
                                    <i
                                      style={{ marginLeft: '5px' }}
                                      class='fas fa-info-circle'
                                      aria-hidden='true'></i>
                                  </a>
                                </div>
                              </div>
                            </>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div class='mcbp-right d-flex align-items-center justify-content-between'>
                  <div class='patients-details-mid'>
                    <div class='pdm-inner-box d-flex align-items-center'>
                      <span>UHID:</span>
                      <p>
                        {data &&
                          data.patient_id &&
                          data.patient_id.yesmindy_identification_number}
                      </p>
                    </div>
                    {/* <div class="pdm-inner-box d-flex align-items-center">
                        <span>Sex:</span>
                        <p>Female</p>
                      </div> */}
                    <div class='pdm-inner-box d-flex align-items-center'>
                      <span>Date of Birth:</span>
                      <p>
                        {data &&
                          data.patient_id &&
                          data.patient_id.date_of_birth &&
                          moment(data.patient_id.date_of_birth).format(
                            'll'
                          )}{' '}
                        (
                        {data &&
                          data.patient_id &&
                          data.patient_id.date_of_birth &&
                          moment().diff(
                            data.patient_id.date_of_birth,
                            'years',
                            false
                          ) + ' yrs'}
                        )
                      </p>
                    </div>
                  </div>
                  <div class='mcbp-right-conent'>
                    <div class='pd-right-box d-flex align-items-center'>
                      <ul class='list-with-icon d-flex align-items-center'>
                        <li>
                          <a
                            href='javascript:void(0)'
                            onClick={e => {
                              e.preventDefault()
                              toggle3()
                            }}
                            class='icon-box orange-icon'
                            data-toggle='modal'
                            data-target='#exampleModalCenter'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='30'
                              height='29.489'
                              viewBox='0 0 30 29.489'>
                              <path
                                class='a'
                                style={{ fill: '#f1964f' }}
                                d='M27.305,38.134H18.8a.817.817,0,0,1-.818-.818V32.163l-4.462,2.574a.818.818,0,0,1-1.113-.3L8.16,27.083a.818.818,0,0,1-.082-.617.861.861,0,0,1,.378-.5l4.462-2.574L8.456,20.82a.8.8,0,0,1-.378-.5.809.809,0,0,1,.082-.617l4.247-7.362a.813.813,0,0,1,1.113-.3l4.462,2.574V9.463a.817.817,0,0,1,.818-.818h8.5a.812.812,0,0,1,.812.818v5.153l4.462-2.574a.812.812,0,0,1,1.113.3L37.941,19.7a.818.818,0,0,1,.082.617.861.861,0,0,1-.378.5L33.182,23.4l4.462,2.574a.8.8,0,0,1,.378.5.809.809,0,0,1-.082.617l-4.247,7.362a.813.813,0,0,1-1.113.3l-4.462-2.574v5.153a.814.814,0,0,1-.811.812Z'
                                transform='translate(-8.05 -8.645)'
                              />
                            </svg>{' '}
                          </a>
                        </li>
                      </ul>
                      <div class='pd-right-dropdown'>
                        <div class='btn-group bottom-align'>
                          <button
                            type='button'
                            class='dropdown-toggle'
                            data-toggle='dropdown'
                            aria-haspopup='true'
                            aria-expanded='false'
                            onClick={e => {
                              e.stopPropagation()
                              setDropDown(!dropDown)
                            }}>
                            <img src={verticalDots} />
                          </button>
                          <div
                            class={
                              dropDown
                                ? 'dropdown-menu dropdown-menu-right show'
                                : 'dropdown-menu dropdown-menu-right'
                            }>
                            <button
                              class='dropdown-item'
                              type='button'
                              onClick={e => {handleAskToJoin(e, data._id)}}
                              disabled={askToJoinClicked}>
                              {askToJoinClicked ? 'Request Sent' : 'Ask to Join'}
                            </button>
                            <button
                              class='dropdown-item'
                              type='button'
                              onClick={e => setPopup({popup: true})}>
                              No Show
                            </button>
                            <button
                              class='dropdown-item'
                              type='button'
                              onClick={e => setPopup2({popup2: true})}>
                                {/* window.close() */}
                              Foreclose
                            </button>
                            <Link
                              target='_blank'
                              class='dropdown-item'
                              type='button'
                              to={
                                '/doctor/patient-detail/history/' +
                                (data && data.patient_id && data.patient_id._id)
                              }>
                              View History
                            </Link>
                            <Link
                              target='_blank'
                              class='dropdown-item'
                              type='button'
                              to={
                                '/doctor/patient-detail/journey/' +
                                (data && data.patient_id && data.patient_id._id)
                              }>
                              View Profile
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class={`${
                  fullScreen
                  ? 'mcb-body-fullscreen'
                  : 'mcb-body'
              } call-end`}>
              
              {loadContent}

              {!fullScreen && (
                <>
                  <div
                    class='fullscreen-button'
                    style={{ cursor: 'pointer' }}
                    onClick={() => toggleFull()}>
                    <img src={fullScreenImg} alt='' />
                  </div>
                  <div id='agora_local' class='front-thumbnail-box'></div>
                </>
              )}
            </div>

            {fullScreen && (
              <>
                <div
                  class='fullscreen-button'
                  style={{ cursor: 'pointer' }}
                  onClick={() => toggleFull()}>
                  <img src={fullScreenImg} alt='' />
                </div>
                <div id='agora_local_full' class='front-thumbnail-box'></div>
              </>
            )}

            <div class={`${fullScreen ? 'mcb-footer-fullscreen' : ''} `}>
              <div className={`${fullScreen ? 'mb-foor-app' : ''} `}>
                <div class='mcb-footer d-flex align-items-center justify-content-between'>
                  <div class='mcb-left'>{moment().format('ll')}</div>
                  <div class='mcb-mid d-flex align-items-center flex-wrap'>
                    <div class='mcb-link' onClick={muteVideo}>
                      <div class='img'>
                        <img src={!video ? videoslash : videosOn} alt='' />
                      </div>
                      <p>Camera</p>
                    </div>
                    <div class='mcb-link' onClick={muteAudio}>
                      <div class='img'>
                        <img src={!audio ? phoneslash : micOn} alt='' />
                      </div>
                      <p>Mic</p>
                    </div>
                    <div
                      class='mcb-link'
                      onClick={()=>{
                        if(!screenShare) handleScreenShareStart();
                        else handleScreenShareEnd();
                      }}
                      >
                      <div class='img'>
                        <img
                          src={!screenShare ? shareIcon : shareClose}
                          alt=''
                        />
                      </div>
                      <p>share</p>
                    </div>
                    <div class='mcb-link leave' onClick={leave}>
                      <div class='img'>
                        <img src={iosExit} alt='' />
                      </div>
                      <p>Leave</p>
                    </div>
                  </div>
                  <div class='mcb-right'>
                    <Timer />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {!fullScreen && (
            <div class='video-sidebar video-sidebar2'>
              <div class='vs-box'>
                <div class='tab-container d-none d-md-block'>
                  <ul
                    class='nav nav-tabs videochat-tabs'
                    id='myTab'
                    role='tablist'>
                    <li class='nav-item' role='presentation'>
                      <a
                        class={
                          tab === 'message' ? 'nav-link active' : 'nav-link'
                        }
                        id='messages-tab'
                        data-toggle='tab'
                        href='#messages'
                        role='tab'
                        aria-controls='messages'
                        aria-selected='true'
                        onClick={e => changeTab('message', e)}
                        data-tooltip-id="videoCall-tt" 
                        data-tooltip-content='Chats will remain active for 3 days. Active chats can be accessed going to the specific date of appointment.'
                        //data-tip='Chats will remain active for 3 days. Active chats can be accessed going to the specific date of appointment. '
                        >
                        {showUnreadDot && (
                          <span style={{
                            position: 'absolute',
                            top: 20,
                            left: 15,
                            height: '10px',
                            width: '10px',
                            backgroundColor: '#8BB044',
                            borderRadius: '50%',
                            display: 'inline-block'
                          }}></span>
                        )}  
                        <i className="fa-solid fa-message-dots fa-lg" style={{ color: "#673ab7" }}></i>
                        <b>Messages</b>
                      </a>
                    </li>
                    <li class='nav-item' role='presentation'>
                      <a
                        class={
                          tab === 'prescriptions'
                            ? 'nav-link active'
                            : 'nav-link'
                        }
                        id='contact-tab'
                        data-toggle='tab'
                        href='#myCaseStudy'
                        role='tab'
                        aria-controls='myCaseStudy'
                        aria-selected='false'
                        onClick={e => changeTab('prescriptions', e)}
                        data-tooltip-id="videoCall-tt" 
                        data-tooltip-content='Prescriptions can only be filled after the appointment is over and CRF is completed.'
                        //data-tip='Prescriptions can only be filled after the appointment is over and CRF is completed.'
                        >
                        <i className="fa-sharp fa-solid fa-file-prescription fa-lg" style={{ color: "#673ab7" }}></i>
                        <b>Prescriptions</b>
                      </a>
                    </li>

                    <li class='nav-item' role='presentation'>
                      <a
                        class={
                          tab === 'follow' ? 'nav-link active' : 'nav-link'
                        }
                        id='contact-tab'
                        data-toggle='tab'
                        href='#myFollowUp'
                        role='tab'
                        aria-controls='myFollowUp'
                        aria-selected='false'
                        onClick={e => changeTab('follow', e)}
                        data-tooltip-id="videoCall-tt" 
                        data-tooltip-content='Follow up note is only from second appointment onwards'
                        //data-tip='Follow up note is only from second appointment onwards'
                        >
                        <i className="fa-sharp fa-solid fa-file-waveform fa-lg" style={{ color: "#673ab7" }}></i>
                        <b>Follow Up</b>
                      </a>
                    </li>
                    <li class='nav-item' role='presentation'>
                      <a
                        class={tab === 'tasks' ? 'nav-link active' : 'nav-link'}
                        id='contact-tab'
                        data-toggle='tab'
                        href='#myTasks'
                        role='tab'
                        aria-controls='myTasks'
                        aria-selected='false'
                        onClick={e => changeTab('tasks', e)}
                        data-tooltip-id="videoCall-tt" 
                        data-tooltip-content='List of patients with current date appointment only. Task can be allotted to any patient from toolbox.'
                        //data-tip='List of patients with current date appointment only. Task can be allotted to any patient from toolbox.'
                        >
                        {' '}
                        <i className="fa-sharp-duotone fa-list-check fa-lg" style={{ "--fa-primary-color": "#673ab7", "--fa-secondary-color": "#673ab7" }}></i>
                        <b>Tasks</b>{' '}
                      </a>
                    </li>
                    <li class='nav-item' role='presentation'>
                      <a
                        class={
                          tab === 'summary' ? 'nav-link active' : 'nav-link'
                        }
                        id='profile-tab'
                        data-toggle='tab'
                        href='#mySummary'
                        role='tab'
                        aria-controls='mySummary'
                        aria-selected='false'
                        onClick={e => changeTab('summary', e)}
                        data-tooltip-id="videoCall-tt" 
                        data-tooltip-content='Smart auto generated treatment summary of the patient for the experts to analyse'
                        //data-tip='Smart auto generated treatment summary of the patient for the experts to analyse'
                        >
                        {' '}
                        <i className="fa-duotone fa-solid fa-clipboard-list fa-lg" style={{ "--fa-primary-color": "#673ab7", "--fa-secondary-color": "#673ab7" }}></i>
                        <b>Summary</b>{' '}
                      </a>
                    </li>
                    <li class='nav-item' role='presentation'>
                      <a
                        class={tab === 'notes' ? 'nav-link active' : 'nav-link'}
                        id='contact-tab'
                        data-toggle='tab'
                        href='#myNotes'
                        role='tab'
                        aria-controls='myNotes'
                        aria-selected='false'
                        onClick={e => changeTab('notes', e)}
                        data-tooltip-id="videoCall-tt" 
                        data-tooltip-content='Notes & Thoughts'
                        //data-tip='Notes & Thoughts'
                        >
                        {' '}
                        <i className="fa-solid fa-thought-bubble fa-lg" style={{ color: "#673ab7" }}></i>
                        <b>Notes & Thoughts</b>{' '}
                      </a>
                    </li>
                  </ul>
                </div>
                <div class='chatbot-body p-md-0'>
                  <div class='tab-content' id='myTabContent'>
                    <div
                      class={
                        tab === 'message'
                          ? 'tab-pane card fade show active'
                          : 'tab-pane card'
                      }
                      id='messages'
                      role='tabpanel'
                      height='50vh'
                      aria-labelledby='messages-tab'>
                      {data && data.patient_id && (
                        <Messeges
                          // appointmentDate={moment(data.appointment_time).format(
                          //   'DD/MM/YYYY'
                          // )}
                          setInitial={() => {
                            setInitial(false)
                          }}
                          initial={initial}
                          patient_id={data.patient_id._id}
                          doctor_id={data.doctor_id._id}
                          tab={tab}
                          showUnreadDot={showUnreadDot}
                        />
                      )}
                    </div>
                    <div className={
                      tab === 'prescriptions'
                        ? 'tab-pane card fade show active'
                        : 'tab-pane card'
                     }>
                      <div className="card-header active mb-3">
                        <i className="fa-sharp fa-solid fa-file-prescription fa-lg" style={{ color: "#673ab7" }}></i>
                        <b>Prescriptions</b>
                      </div> 
                      <Scrollbars
                        className={
                          tab === 'prescriptions'
                            ? 'tab-pane card fade show active'
                            : 'tab-pane card'
                        }
                        autoHeight
                        autoHeightMin={0}
                        autoHeightMax={'65vh'}>
                        {data && data.patient_id && (
                          <ListPrescription
                            tab={tab}
                            yesmindy_identification_number={
                              data.patient_id.yesmindy_identification_number
                            }
                            id={data.patient_id._id}
                            first_name={data.patient_id.first_name}
                            last_name={data.patient_id.last_name}
                            age={data.patient_id.date_of_birth}
                            sex={data.patient_id.sex}
                            image={data.patient_id.thumb}
                            star={data.patient_id.star}
                            time={data.appointment_time}
                            caseRecord={caseRecord}
                          />
                        )}
                      </Scrollbars>
                    </div>

                    <div
                      class={
                        tab === 'follow'
                          ? 'tab-pane card fade show active'
                          : 'tab-pane'
                      }
                      id='messages'
                      role='tabpanel'
                      aria-labelledby='messages-tab'>
                      <div className="card-header active mb-3">
                        <i className="fa-sharp fa-solid fa-file-waveform fa-lg" style={{ color: "#673ab7" }}></i>
                        <b>Follow Up</b>
                      </div>  
                      <Scrollbars
                        class={
                          tab === 'follow'
                            ? 'tab-pane card fade show active'
                            : 'tab-pane card'
                        }
                        autoHeight
                        autoHeightMin={0}
                        autoHeightMax={'65vh'}>
                        {data && data.patient_id && (
                          <ListFollowup
                            isVideoCall={true}
                            tab={tab}
                            yesmindy_identification_number={
                              data.patient_id.yesmindy_identification_number
                            }
                            id={data.patient_id._id}
                            first_name={data.patient_id.first_name}
                            last_name={data.patient_id.last_name}
                            age={data.patient_id.date_of_birth}
                            sex={data.patient_id.sex}
                            image={data.patient_id.thumb}
                            star={data.patient_id.star}
                            time={data.appointment_time}
                            caseRecord={caseRecord}
                          />
                        )}
                      </Scrollbars>
                    </div>
                    {/* <div
                      class={
                        tab === 'follow'
                          ? 'tab-pane card fade show active'
                          : 'tab-pane'
                      }
                      id="messages"
                      role="tabpanel"
                      aria-labelledby="messages-tab"
                    >
                      {tab === 'follow' && (
                        <Followup
                          appointment_date={props.appointment_date}
                          video={true}
                          id={data.patient_id._id}
                          tab={tab}
                        />
                      )}
                    </div> */}
                    <div
                      class={
                        tab === 'tasks'
                          ? 'tab-pane card fade show active'
                          : 'tab-pane card'
                      }
                      id='messages'
                      role='tabpanel'
                      aria-labelledby='messages-tab'>
                      {data &&
                        data.patient_id &&
                        data.patient_id._id &&
                        tab === 'tasks' && (
                          <Task videoCall={true} id={data.patient_id._id} />
                        )}
                    </div>
                    <div
                      class={
                        tab === 'summary'
                          ? 'tab-pane card fade show active'
                          : 'tab-pane card'
                      }
                      id='messages'
                      role='tabpanel'
                      aria-labelledby='messages-tab'>
                      {data &&
                        data.patient_id &&
                        data.patient_id._id &&
                        tab === 'summary' && (
                          <SummaryVid
                            videoCall={true}
                            id={data.patient_id._id}
                            detail={props.detailData}
                          />
                        )}
                    </div>          
                    <div
                      class={
                        tab === 'notes'
                          ? 'tab-pane card fade show active'
                          : 'tab-pane card'
                      }
                      id='messages'
                      role='tabpanel'
                      aria-labelledby='messages-tab'>
                      <div className="card-header mb-3">
                        <i className="fa-solid fa-thought-bubble fa-lg" style={{ color: "#673ab7" }}></i>
                        <b>Notes & Thoughts</b>
                      </div>    
                      {data &&
                        data.patient_id &&
                        data.patient_id._id &&
                        tab === 'notes' && (
                          <NotesThoughtVideoCall
                            appoint_id={data._id}
                            patientId={data.patient_id._id}
                            doctorId={data.doctor_id._id}
                            patientType={data.patient_id.type}
                          />
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <SettingPopup
        isShow={isShow3}
        toggle={toggle3}
        detail={props.detailData.data}
      />
      
      <Modal
        aria-labelledby='contained-modal-title-vcenter'
        centered
        dialogClassName='modal-dialog modal-dialog-centered modal-sm'
        className='modal fade '
        show={popup}>
        <>
          <div class='modal-header'>
            <button
              onClick={() => {
                setPopup(!popup)
              }}
              type='button'
              class='close'
              data-dismiss='modal'>
              <img src={closeIcon} alt='close popup' />
            </button>
          </div>
          <div class='modal-body'>
            <p>You are requesting for No Show protocol to initiate as the patient didnt join till 20mins into the appointment. Are you sure you want to proceed ?</p>
            <p style={{ fontSize: '13px', color: '#666' }}>(You can also ask the patient to join through a whatsapp message by clicking on option "Ask to join" from menu above)</p>
            <div class='modal-action-btn'>
              <a
                href='#!'
                class='btn btn-outline no-shadow'
                data-dismiss='modal'
                aria-label='Close'
                onClick={e => {
                  e.preventDefault()
                  setPopup(!popup)
                }}>
                Close
              </a>
              <a
                href='#!'
                class='btn btn-primary'
                data-dismiss='modal'
                aria-label='Close'
                onClick={en => {
                  noShow(en, data._id)
                  setPopup(!popup)
                  }}>
                Confirm
              </a>
            </div>
          </div>
        </>
      </Modal>      
      <Modal
        aria-labelledby='contained-modal-title-vcenter'
        centered
        dialogClassName='modal-dialog modal-dialog-centered modal-sm'
        className='modal fade '
        show={popup2}>
        <>
          <div class='modal-header'>
            <button
              onClick={() => {
                setPopup2(!popup2)
              }}
              type='button'
              class='close'
              data-dismiss='modal'>
              <img src={closeIcon} alt='close popup' />
            </button>
          </div>
          <div class='modal-body'>
            <p>You are about to initiate the "Foreclosure" protocol as you find the patient unfit for online consultation and want to send notice to the patient about the same to remain legally safe. Are you sure you want to proceed ?</p>
            <div class='modal-action-btn'>
              <a
                href='#!'
                class='btn btn-outline no-shadow'
                data-dismiss='modal'
                aria-label='Close'
                onClick={e => {
                  e.preventDefault()
                  setPopup2(!popup2)
                }}>
                Close
              </a>
              <a
                href='#!'
                class='btn btn-primary'
                data-dismiss='modal'
                aria-label='Close'
                onClick={e => handelForclose(e, data._id)}>
                Confirm
              </a>
            </div>
          </div>
        </>
      </Modal>
    </>
  )
}
const mapDispatchToProps = dispatch => ({
  loadSeo: page_key => dispatch(loadSeo(page_key)),
  loadDoctorProfile: () => dispatch(loadDoctorProfile()),
  loadAppointmentDetail: (id, callback) =>
    dispatch(loadAppointmentDetail(id, callback)),
  loadList: params => dispatch(loadList(params)),
  patientDetail: id => dispatch(patientDetail(id)),
  loadAllAppointmentForDoctor: params =>
    dispatch(loadAllAppointmentForDoctor(params)),
  asktoJoin: (data, callback) => dispatch(asktoJoin(data, callback)),
  noShow: (id, callback) => dispatch(noShow(id, callback)),
  foreClose: (id, callback) => dispatch(foreClose(id, callback)),
})
const mapStateToProps = state => ({
  profileLoading: getDoctor(state).profileLoading,
  doctorProfile: getDoctor(state).profile,
  getAppointment: getAppointment(state).doctorAppointment,
  detailData: getPatient(state).patientDetail,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VideoCall)
)
